import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import selectors from "selectors";
import moment from "moment";
import { cancelAppointment } from "actions/chat";
import { convertDateToLocal, getBrowserTimezone } from "utils/misc";

export const useAppointmentLogic = (chats, master_chat_type) => {
  const [displaySpinner, setDisplaySpinner] = useState(false);
  const dispatch = useDispatch();
  const speaksSpanish = useSelector(selectors.getSpeaksSpanish);
  const browserTimezone = getBrowserTimezone();
  const { chat_details, topic_details } = chats[0];

  const is_confirmed =
    chat_details.meeting_status !== "Un-confirmed" &&
    chat_details.meeting_status !== "declined";

  const is_cancelled = chat_details.meeting_status === "canceled";

  const getCurrentTime = () => {
    return {
      days: moment.utc(timeUntilAppointment.as("milliseconds")).format("D") - 1,
      hours: moment.utc(timeUntilAppointment.as("milliseconds")).format("H"),
      minutes: moment(timeUntilAppointment.as("milliseconds") + 60000).format(
        "mm"
      )
    };
  };

  const getStatusColor = meeting_status => {
    var statusColor = { backgroundColor: "white", color: "black" };

    switch (meeting_status) {
      case "completed":
        statusColor.backgroundColor = "rgb(19, 180, 255)";
        break;
      case "Confirmed":
        statusColor.backgroundColor = "rgb(0, 92, 31)";
        statusColor.color = "white";
        break;
      case "declined":
        statusColor.backgroundColor = "rgb(174, 22, 62)";
        statusColor.color = "white";
        break;
      case "rescheduled":
        statusColor.backgroundColor = "rgb(19, 180, 255)";
        break;
      case "Un-confirmed":
        statusColor.backgroundColor = "rgb(245, 143, 8)";
        break;
      case "canceled":
        statusColor.backgroundColor = "rgb(242, 21, 21)";
        statusColor.color = "white";
    }

    return statusColor;
  };

  const timeUntilAppointment = moment.duration(
    moment
      .tz(chat_details.start_time, "America/Chicago")
      .diff(moment().tz(browserTimezone))
  );

  const { days, hours, minutes } = getCurrentTime();
  const [remainingTime, setRemainingTime] = useState({ days, hours, minutes });

  useEffect(() => {
    const msUntilNextMinute = 60000 - (Date.now() % 60000);

    const timeout = setTimeout(() => {
      const { hours, minutes } = getCurrentTime();
      setRemainingTime(prev => ({
        ...prev,
        hours,
        minutes: minutes == 0 ? "59" : minutes - 1
      }));
    }, msUntilNextMinute);

    return () => clearTimeout(timeout);
  }, [getCurrentTime, setRemainingTime]);

  const onCancelAppointment = async (slot_id, closeModal) => {
    setDisplaySpinner(true);
    await dispatch(cancelAppointment(slot_id));
    setDisplaySpinner(false);
    closeModal();
  };

  const startTimeFromCSTToBrowser = convertDateToLocal(
    chat_details.start_time,
    false
  ).toDate();
  const endTimeFromCSTToBrowser = convertDateToLocal(
    chat_details.end_time,
    false
  ).toDate();

  return {
    displaySpinner,
    speaksSpanish,
    browserTimezone,
    chat_details,
    topic_details,
    is_confirmed,
    is_cancelled,
    getStatusColor,
    remainingTime,
    onCancelAppointment,
    startTimeFromCSTToBrowser,
    endTimeFromCSTToBrowser,
    timeUntilAppointment
  };
};
